import { Nullable } from "../../../../../common/types/nullable";
import {
  AccumDateData,
  AccumulationsForEmploymentResponse,
} from "../../../../employment/employmentApi";
import {
  AccumulationField,
  AccumulationType,
  EventSummary,
  SelectedAccumulation,
} from "../types";
import AccumulationsEditForm from "./editForm/AccumulationsEditForm";
import AccumulationsEditTable from "./editTable/AccumulationsEditTable";
import { useContext } from "react";
import { AccessRightContext } from "../../../../user/AccessRightProvider";

type Props = {
  accumulationType: AccumulationType;
  employmentId?: string;
  contEmpId?: string;
  onClose: () => void;
  tableData: AccumulationsForEmploymentResponse;
  updateLocalTableData: (date: string, data: EventSummary[]) => void;
  selectedAccumulation: Nullable<SelectedAccumulation>;
  selectedAccumulationRow: Nullable<AccumDateData>;
};

const AccumulationEditComponent = ({
  accumulationType,
  employmentId,
  contEmpId,
  onClose,
  tableData,
  updateLocalTableData,
  selectedAccumulation,
  selectedAccumulationRow,
}: Props) => {
  const { canEditAccumulations } = useContext(AccessRightContext);

  const getFields = (
    tableData: AccumulationsForEmploymentResponse,
    selectedAccumulation: SelectedAccumulation,
  ): [AccumulationField[], AccumulationField[]] => {
    const keys =
      tableData?.meta?.keys.map((key) => ({ label: key, name: key })) || [];
    const stateNames =
      tableData?.meta?.stateNames.map((name, index) => ({
        label: selectedAccumulation?.displayNames[index] || name,
        name,
      })) || [];
    return [keys, stateNames];
  };

  return (
    <>
      {selectedAccumulation?.isInternal ? (
        <>
          <AccumulationsEditTable
            accumulationType={accumulationType}
            employmentId={employmentId}
            contEmpId={contEmpId}
            tableData={tableData}
            onClose={onClose}
            selectedAccumulationRow={selectedAccumulationRow}
            getFields={getFields}
            selectedAccumulation={selectedAccumulation}
            updateLocalTableData={updateLocalTableData}
            canEdit={canEditAccumulations}
          />
        </>
      ) : (
        <AccumulationsEditForm
          onClose={onClose}
          accumulationType={accumulationType}
          employmentId={employmentId}
          contEmpId={contEmpId}
          tableData={tableData}
          updateLocalTableData={updateLocalTableData}
          selectedAccumulation={selectedAccumulation}
          getFields={getFields}
          canEdit={canEditAccumulations}
        />
      )}
    </>
  );
};

export default AccumulationEditComponent;
